// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import {
	Toast,
	Dialog,
	Lazyload,
	Sticky,
	ImagePreview
} from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入模块后自动生效
import '@vant/touch-emulator';
import util from './utils/util.js';
import request from './utils/request.js';
import cookieManager from './utils/cookieManager.js';
import enumManager from './utils/enumManager.js';
import pinyin from 'js-pinyin';
pinyin.setOptions({
	checkPolyphone: false,
	charCase: 0
});

import {
	Loading
} from 'element-ui';

//自定义组件
import topAdmin from '@/components/top-admin.vue'
Vue.component('top-admin', topAdmin)

import top from '@/components/top.vue'
Vue.component('top', top)

import menuLeft from '@/components/menu-left.vue'
Vue.component('menu-left', menuLeft)

import customBottom from '@/components/custom-bottom.vue'
Vue.component('custom-bottom', customBottom)

import myEditor from '@/components/my-editor.vue'
Vue.component('my-editor', myEditor);

Toast.setDefaultOptions({
	overlay: true
})
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Vant)
Vue.use(ElementUI);
Vue.use(Lazyload, {
	lazyComponent: true
});
Vue.use(Sticky);
Vue.use(ImagePreview);

Vue.config.productionTip = false

Vue.prototype.$request = request;
Vue.prototype.$util = util;
Vue.prototype.$cookie = cookieManager;
Vue.prototype.$enum = enumManager;
Vue.prototype.$loading = Loading;
Vue.prototype.$service = {
	// lock: true, // 是否锁屏
	text: '正在加载...', // 加载动画的文字
	spinner: 'el-icon-loading', // 引入的loading图标
	background: 'rgba(0, 0, 0, 0.7)', // 背景颜色
	body: true,
	fullscreen: true // 全屏开关
}
Vue.prototype.$toast = Toast;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})

router.afterEach(to => {
	document.title = '卢卡狮集团-' + to.meta.title;
})



// WEBPACK FOOTER //
// ./src/main.js